import { LoginForm } from 'ui/components/supporter/patterns/LoginForm/LoginForm';

/**
 * サポーターログインページ
 */
export const SupportLogin: React.FC = () => {
    return <LoginForm />;
};
